module.exports = __webpack_public_path__ + "media/images/socials/youtube-c432a4184940256be88e0ba507fbad25.png";